import React from "react";
import { VLYT } from "@/constants/testIds/vlyt";
import useReveal from "@/hooks/useReveal";
import { MapPin, ShieldCheck, Sparkles, Wallet, Route, HeartHandshake } from "lucide-react";

const FEATURES = [
  {
    icon: MapPin,
    title: "Campus-first geofence",
    body: "Optimized for Hebron gates, hostels, and lecture halls. Every pickup point is student-mapped.",
  },
  {
    icon: ShieldCheck,
    title: "Verified riders only",
    body: "Matric-number-linked accounts. No random strangers, ever.",
  },
  {
    icon: Wallet,
    title: "Transparent fares",
    body: "Fares locked at booking. Zero surge. Zero surprises.",
  },
  {
    icon: Route,
    title: "Virtual Queue Logic",
    body: "Booking a Vlyt is a reservation, not just a request. Secure your specific slot at the shuttle stand and receive real-time minutes-to-stand updates that work even on low-connectivity campus WiFi.",
  },
  {
    icon: HeartHandshake,
    title: "Driver-first economics",
    body: "Drivers keep 95 percent of the fare. Vlyt maintains a flat, transparent ₦10 platform fee to keep the infrastructure running at peak performance.",
  },
  {
    icon: Sparkles,
    title: "Royal priority",
    body: "Royal Daily Pass members skip the queue with a 4-minute match guarantee.",
  },
];

export default function FeaturesGrid() {
  const { ref, inView } = useReveal({ threshold: 0.15 });
  return (
    <section
      ref={ref}
      data-testid={VLYT.features.section}
      className="relative py-28 md:py-36 border-b border-[color:var(--vlyt-border)]"
    >
      <div className="mx-auto max-w-[1440px] px-5 md:px-10">
        <div className={`reveal ${inView ? "in" : ""} max-w-3xl mb-14`}>
          <div className="text-eyebrow mb-5">04 · Platform</div>
          <h2 className="text-h1 font-display">
            Everything you need. <span className="text-lime">Nothing you don't.</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {FEATURES.map((f, i) => {
            const Icon = f.icon;
            return (
              <div
                key={f.title}
                className={`reveal ${inView ? "in" : ""} card-hover relative rounded-[20px] border border-[color:var(--vlyt-border)] bg-[color:var(--vlyt-surface-1)] p-7`}
                style={{ transitionDelay: `${i * 60}ms` }}
              >
                <div className="h-11 w-11 rounded-xl bg-[rgba(191,255,0,0.07)] flex items-center justify-center ring-1 ring-[color:var(--vlyt-border)] mb-5">
                  <Icon size={18} className="text-lime" />
                </div>
                <div className="font-display text-[18px]">{f.title}</div>
                <p className="text-[color:var(--vlyt-muted)] text-[14px] mt-2 leading-relaxed">{f.body}</p>
                <div className="absolute top-6 right-6 font-mono text-[11px] text-[color:var(--vlyt-muted)]">
                  0{i + 1}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
